import React from 'react'

export const Cheakout = () => {
  return (
    <h1>Thanks for your order</h1>
  )
}

